export default "__VITE_ASSET__BzrKBfow__"